import { CaseStatus, OrganType } from '@/api/apis/case';
import { isAllowedStatus } from '@/utils/helpers';

type TrialProgramLike = {
  id?: string;
  name?: string;
  organ?: string | null;
  isActive?: boolean | null;
};

type QuestionnaireEditControlState = {
  isVisible: boolean;
  isDisabled: boolean;
  canTurnOn: boolean;
  canTurnOff: boolean;
  forceEnabled: boolean;
};

export const hasActiveTrialProgramForOrgan = (
  organType?: OrganType,
  trialPrograms?: TrialProgramLike[] | null,
): boolean => {
  if (!organType || !trialPrograms?.length) return false;

  return trialPrograms.some((program) => !!program?.isActive && program.organ === organType);
};

export const getQuestionnaireEditControlState = ({
  status,
  organType,
  txCenterTrialPrograms,
}: {
  status?: CaseStatus;
  organType?: OrganType;
  txCenterTrialPrograms?: TrialProgramLike[] | null;
}): QuestionnaireEditControlState => {
  const isTrialTxCenter = hasActiveTrialProgramForOrgan(organType, txCenterTrialPrograms);

  if (!isTrialTxCenter) {
    return {
      isVisible: true,
      isDisabled: true,
      canTurnOn: false,
      canTurnOff: false,
      forceEnabled: false,
    };
  }

  const isClinicalScreeningWindow =
    !!status &&
    isAllowedStatus({
      statusFrom: CaseStatus.ClinicalScreening,
      statusTo: CaseStatus.Accepted,
      currentStatus: status,
    });

  if (isClinicalScreeningWindow) {
    return {
      isVisible: true,
      isDisabled: true,
      canTurnOn: false,
      canTurnOff: false,
      forceEnabled: true,
    };
  }

  const isPendingLogisticsWindow =
    !!status &&
    isAllowedStatus({
      statusFrom: CaseStatus.PendingLogistics,
      statusTo: CaseStatus.DeployedToTXCenter,
      currentStatus: status,
    });

  if (isPendingLogisticsWindow) {
    return {
      isVisible: true,
      isDisabled: false,
      canTurnOn: true,
      canTurnOff: true,
      forceEnabled: false,
    };
  }

  return {
    isVisible: true,
    isDisabled: true,
    canTurnOn: false,
    canTurnOff: false,
    forceEnabled: false,
  };
};
